import { OrderItem } from "@omni/types/api/cart/bff/shared/orderItem.model";
import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import * as OrderUtils from "@omni/utils/order.utils";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { cartDeliveryPromiseTranslationKey } from "@/utils/deliveryPromise";

type DeliveryPromiseComponentProps = {
    item: OrderItem;
    deliveryType: DeliveryType;
};

const DeliveryPromiseComponent = ({
    item,
    deliveryType
}: DeliveryPromiseComponentProps) => {
    const { t } = useGranite();

    const deliveryPromiseTk = cartDeliveryPromiseTranslationKey({
        deliveryPromise: item.deliveryPromise,
        deliveryType: deliveryType
    });

    const isBoxEntry = OrderUtils.isBoxEntry(item);

    return (
        <p className={"m-0"}>
            {!item.warrantyDeposit &&
                (!isBoxEntry ||
                    (isBoxEntry &&
                        deliveryType === DeliveryType.HomeDelivery)) &&
                deliveryPromiseTk &&
                t(
                    deliveryPromiseTk,
                    item.deliveryPromise?.deliveryTime,
                    t(
                        `product.deliveryPromise.timeUnits.${item.deliveryPromise?.deliveryTimeUnit}`
                    )
                )}
            {isBoxEntry &&
                deliveryType === DeliveryType.ClickAndCollect &&
                (item.product?.boxLogisticInformation ||
                    t(`ecommerce.label.pickup.box.${item.sku}`))}
        </p>
    );
};

export { DeliveryPromiseComponent };
